import { otrom, otro, all } from './services/service'

export const mergeAbility = (services) => {

  const finalAbility = [
    {
      action: 'read',
      subject: 'MsgAuto'
    }

  ]
    services.forEach(service => {
      if (service === 'otro')  finalAbility.push(otro)
      if (service === 'otrom')  finalAbility.push(otrom)
      if (service === 'all')  finalAbility.push(all)
                              })
    return finalAbility

}

export const clientAbility = () => [
  { action: 'read', subject: 'MsgAuto' },
  { action: 'read', subject: 'Auth' }
]

export const adminAbility = () => [{ action: 'manage', subject: 'all' }]
